// Sapiobot Bundle — Robot + Abonnement obligatoire
const ABONNEMENT_VARIANT_ID = '63547982250314';
const ROBOT_TAGS = ['robot'];
let isSyncing = false;

async function getCart() {
  return fetch('/cart.js').then(r => r.json());
}

async function updateCart(updates) {
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });
  if (!res.ok) { console.warn('cart/update.js error:', res.status); return null; }
  return res.json();
}

async function injectSapioButtons() {
  const cart = await getCart();
  const summary = document.querySelector('#cart-drawer .cart-drawer__summary');
  if (!summary) return;

  const robotItem = cart.items.find(i => String(i.variant_id) !== ABONNEMENT_VARIANT_ID);
  if (!robotItem) return;

  const v = String(robotItem.variant_title || robotItem.title || '').toLowerCase();
  const mode = v.includes('achat') ? 'achat' : v.includes('leasing') ? 'leasing' : null;
  if (!mode) return;

  summary.querySelector('#sapio-injected')?.remove();

  const div = document.createElement('div');
  div.id = 'sapio-injected';
  div.style.cssText = 'display:flex;flex-direction:column;gap:12px;width:100%;margin-top:8px;';
  div.innerHTML = `
    ${mode === 'achat' ? `<a href="/checkout" class="button" style="width:100%;text-align:center;background:#C9A84C;color:#000;border:none;">Acheter</a>` : ''}
    ${mode === 'leasing' ? `<button id="sapio-btn-leasing" class="button" style="width:100%;text-align:center;background:#C9A84C;color:#000;border:none;cursor:pointer;">Contrat de Leasing</button>` : ''}
    <button id="sapio-btn-devis" class="button button--secondary" style="width:100%;text-align:center;cursor:pointer;">Obtenir un devis</button>
    <div style="padding:12px;border:1px solid rgba(201,168,76,0.4);background:rgba(201,168,76,0.05);font-size:0.875rem;color:rgba(255,255,255,0.75);">
      <strong style="color:#C9A84C;">Abonnement Sapiobot Control</strong><br>
      Un mandat SEPA de 150€ HT/mois vous sera envoyé par email après confirmation.
    </div>
  `;
  summary.appendChild(div);

  summary.querySelector('#sapio-btn-leasing')?.addEventListener('click', () => { window.location.href = '/pages/demande-de-leasing'; });
  summary.querySelector('#sapio-btn-devis')?.addEventListener('click', () => { window.location.href = '/pages/demande-de-devis'; });

  summary.querySelectorAll('[name="checkout"], a[href="/checkout"].button--primary').forEach(el => el.style.display = 'none');
}

async function syncAbonnement() {
  if (isSyncing) return;
  isSyncing = true;
  try {
    const cart = await getCart();
    let qtyRobots = 0;
    for (const item of cart.items) {
      if (item.product_tags && ROBOT_TAGS.some(tag => item.product_tags.includes(tag))) {
        qtyRobots += item.quantity;
      }
    }
    const abonnementItem = cart.items.find(i => String(i.variant_id) === ABONNEMENT_VARIANT_ID);
    const qtyActuelle = abonnementItem ? abonnementItem.quantity : 0;
    if (qtyActuelle !== qtyRobots) {
      const updates = {};
      updates[ABONNEMENT_VARIANT_ID] = qtyRobots;
      await updateCart(updates);
    }
  } finally {
    isSyncing = false;
  }
}

const drawerObserver = new MutationObserver(() => {
  const summary = document.querySelector('#cart-drawer .cart-drawer__summary');
  if (summary && !summary.querySelector('#sapio-injected')) {
    injectSapioButtons();
  }
});
drawerObserver.observe(document.body, { childList: true, subtree: true });

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[name="add"], .btn-add-to-cart, [data-add-to-cart]');
  if (btn) setTimeout(syncAbonnement, 500);
});

document.addEventListener('change', (e) => {
  if (e.target.closest('.cart-quantity, [name="updates[]"]')) setTimeout(syncAbonnement, 300);
});
